/**
 * Enum loại section
 */
export default {
    Group: 1, // nhóm
    SubGroup: 2, // tiểu nhóm
    Item: 3, // mục
    SubItem: 4 // tiểu mục
  };
  